import {Controller} from "@hotwired/stimulus";

/**
 * History controller allows to update the browser's history state by pushing
 * a new URL. The controller removes itself after updating the history.
 */
export default class extends Controller {
  static values = {
    href: String
  }

  connect() {
    history.pushState(null, '', this.hrefValue);
    this.element.remove();
  }
}